import { PendingSubscriptionEvent } from "../../../../../types"
import {
  DEFAULT_DATETIME_SECONDS_SLASH_FORMAT,
  formatDateTimeFromTimestamp
} from "../../../../utils"
import ActivityIcon from "./icon"
import Summary from "./summary"

interface Props {
  event: PendingSubscriptionEvent

  connectorVisible?: boolean
}

const ActivityRow = ({ event, connectorVisible = true }: Props) => {
  const { event_type, created } = event

  return (
    <div className="flex items-center justify-between py-3 max-w-xl md:max-w-3xl">
      <div className="flex items-center">
        <ActivityIcon
          event_type={event_type}
          connectorVisible={connectorVisible}
        />
        <div className="ml-4 text-primary-alt-400">
          <Summary event={event} />
        </div>
      </div>
      <div className="text-neutral-400 whitespace-nowrap">
        {formatDateTimeFromTimestamp(
          created,
          DEFAULT_DATETIME_SECONDS_SLASH_FORMAT
        )}
      </div>
    </div>
  )
}

export default ActivityRow
